import React, { useState, useEffect } from 'react'
import { get } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { List, IconCheckmark, IconDisabled } from 'shared/components'
import { sendErrorReport, displayValue, formatDate } from 'shared/helpers'
import { fetchOrders } from 'src/LicenseManager/actions'

export default function Orders({ filterByCustomerAccount }) {
  const { managerId, companyId } = useParams()
  const history = useHistory()
  const [list, setList] = useState([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)

  const updateOrders = page => {
    setLoading(true)
    fetchOrders(companyId, managerId, filterByCustomerAccount, page)
      .then(res => {
        setList(get(res, 'data'))
        setLoading(false)
      })
      .catch(err => {
        sendErrorReport(err, 'Cannot get customer licenses')
        setLoading(false)
      })
  }

  useEffect(() => {
    updateOrders(page)
  }, [page, filterByCustomerAccount])

  const handleUserPageChange = page => {
    setPage(page)
    updateOrders(page)
  }

  const redirectToOrderPage = rowData => {
    const orderID = get(rowData, 'original.id')
    history.push(`/${companyId}/orders/${orderID}`)
  }

  return (
    <List
      clickable
      data={get(list, 'results') || []}
      loading={loading}
      manual
      page={page}
      pages={Math.ceil(get(list, 'count') / 20)}
      minRows={2}
      showPagination
      onPageChange={handleUserPageChange}
      handleClick={rowData => redirectToOrderPage(rowData)}
      columns={[
        {
          accessor: 'created_at',
          Header: __('Created on'),
          Cell: cellInfo => formatDate(cellInfo.value),
          width: 180
        },
        {
          accessor: 'store_id',
          Header: __('Order ID'),
          Cell: cellInfo => displayValue(cellInfo.value),
          minWidth: 200
        },
        {
          accessor: 'campaign_params',
          Header: __('Campaign parameters'),
          Cell: cellInfo => displayValue(cellInfo.value)
        },
        {
          accessor: 'download_id',
          Header: __('Download ID'),
          Cell: cellInfo => displayValue(cellInfo.value)
        },
        {
          accessor: 'has_active_licenses',
          Header: __('Has active licenses'),
          headerClassName: 'text-center',
          className: 'text-center',
          Cell: cellData =>
            cellData.value ? (
              <IconCheckmark color='#10ac84' height='14px' />
            ) : (
              <IconDisabled color='red' height='14px' />
            )
        }
      ]}
    />
  )
}
